module.exports = __webpack_public_path__ + "static/media/icon_attribute.0f3711ed.svg";